export const initCategoryShowcase = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".category-showcase__swiper",
  );

  if (sliders.length === 0) return;

  // Extract Swiper and its modules from the Core Plugin's global vendor object
  const rawSwiper = window.EcommerceCore.vendors.Swiper;
  const Swiper = (rawSwiper as any).default || rawSwiper;
  const { Pagination, Autoplay } = window.EcommerceCore.vendors.SwiperModules;

  sliders.forEach((el) => {
    // Prevent double initialization
    if (el.dataset.initialized === "true") return;
    el.dataset.initialized = "true";

    const slideCount = el.querySelectorAll(".swiper-slide").length;
    // We display 5 slides on desktop, so we need more than 5 to safely loop
    const enableLoop = slideCount > 5;

    new Swiper(el, {
      // Use the extracted modules
      modules: [Pagination, Autoplay],
      observer: true,
      observeParents: true,
      slidesPerView: 2, // Mobile default
      spaceBetween: 20,
      loop: enableLoop,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        540: { slidesPerView: 3, spaceBetween: 20 },
        768: { slidesPerView: 4, spaceBetween: 30 },
        1024: { slidesPerView: 5, spaceBetween: 40 }, // 5 items on desktop
      },
    });
  });

  console.log("[Slider] Category Showcase initialized.");
};
